import { defineMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconSearch } from '#src/atoms/icons/system/iconSearch.ts';
import { TextInput } from '#src/atoms/inputs/TextInput/index.tsx';
import { useShortcutWithKeys } from '#src/hooks/useShortcutWithKeys.tsx';
import { useToggle } from '#src/hooks/useToggle.ts';

import { SearchBarDialog } from './SearchBarDialog/index.tsx';

const StyledTextInput = styled(TextInput)`
  background: rgba(var(--c-rgb-white), 0.04);
  border: 1px solid var(--c-nd-50);
  &,
  & * {
    text-align: left;
    cursor: pointer;
  }

  &:hover {
    border-color: var(--c-nd-150);
  }
  transition: 300ms border-color ease-in-out;
`;

const placeholder = defineMessage({
  defaultMessage: 'Search...',
});

export const SearchBar = () => {
  const { formatMessage } = useIntl();
  const [searchDialogOpened, toggleSearchDialogOpened] = useToggle(false);

  const { Icon: searchShortcut } = useShortcutWithKeys(
    'cmdk',
    () => {
      toggleSearchDialogOpened();
    },
    [toggleSearchDialogOpened]
  );

  return (
    <>
      <StyledTextInput
        type="button"
        onClick={toggleSearchDialogOpened}
        startAdornment={
          <FontAwesomeIcon icon={iconSearch} color="var(--c-nd-600)" />
        }
        value={formatMessage(placeholder)}
        endAdornment={searchShortcut}
      />
      <SearchBarDialog
        open={!!searchDialogOpened}
        onClose={() => toggleSearchDialogOpened()}
      />
    </>
  );
};
